import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {ApartmentViewModal} from './appartment.viewmodal'
import {
  SEARCH_AUTOCOMPLETE,
  SEARCH_MODULE_NAMESPACE,
  SEARCH_REQUEST_BYID,
  SEARCH_REQUEST_BYKEYS
} from '../../../../store/search'
import {CrudStatus, SearchEntities} from '../../../../common/enums'
import {
  BLOCK_GET_BLOCK,
  BLOCK_GET_BLOCKS_AUTOCOMPLETE,
  BLOCK_GET_BLOCKS_BYQUERY,
  BLOCK_MODULE_NAMESPACE
} from '../../../../store/block'
import {IBlockParameter} from '../../../../models/block'
import {APARTMENT_MODULE_NAMESPACE} from '../../../../store/apartment'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)

@Component
class ApartmentVerticalModal extends ApartmentViewModal {
  dtRules: {
    numRules?: any,
    floorRules?: any,
    surfaceRules?: any,
    typeRules?: any,
    blockRules?: any,
    tenantRules?: any,
    ownerRules?: any,
    buildingName?: any,
    emailRules?: any
  }

  /* eslint-disable no-undef */
  dtTenants: any[]
  dtOwners: any[]
  dtBlocks: any[]
  dtIsValidLandline: boolean

  constructor () {
    super()
    this.dtRules = {}
    this.dtTenants = []
    this.dtOwners = []
    this.dtBlocks = []
    this.dtIsValidLandline = false
  }

  @Prop({default: null, type: [Number]})
  blockId: number | null

  @Prop({default: false, type: [Boolean]})
  creationSuccess: boolean

  @SearchStore.Action(SEARCH_REQUEST_BYID)
  storeSearchEntityById: (entityId: number) => Promise<any>

  @SearchStore.Action(SEARCH_REQUEST_BYKEYS)
  storeGetMasterData: (keys: SearchEntities[]) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntityAutocomplete: (payload: { entity: SearchEntities, query: string, limit?: number }) => Promise<any>;

  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCKS_BYQUERY)
  storeGetBlocksByQuery: (query: string) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockById: (blockId: string) => Promise<any>

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @ApartmentStore.Getter apartmentCrudActionStatus: CrudStatus

  created () {
    if (this.blockId) {
      this.storeGetBlockById(this.blockId.toString())
        .then(block => {
          this.block = this.blockId
          this.coBlocks = [block]
        })
    }

    if (this.isUpdateAction) {
      if (this.apartment.owner && this.apartment.owner.length) {
        Promise.all(this.apartment.owner.map(owner => this.storeSearchEntityById(owner)))
          .then(ownerEntities => {
            if (ownerEntities && ownerEntities.length) this.coOwners = ownerEntities
          })
      }

      if (this.apartment.tenant && this.apartment.tenant.length) {
        Promise.all(this.apartment.tenant.map(tenant => this.storeSearchEntityById(tenant)))
          .then(tenantEntities => {
            if (tenantEntities && tenantEntities.length) this.coTenants = tenantEntities
          })
      }
    }
  }

  mounted () {
    this.dtRules = {
      blockRules: [(v) => (!!v && v.length > 0) || this.$t(this.lblSetting.apartmentEntityRequired, {entity: this.$t(this.lblSetting.lblBlock)})],
      tenantRules: [(v) => !!v || this.$t(this.lblSetting.apartmentEntityRequired, {entity: this.$t(this.lblSetting.lblOwner)})],
      ownerRules: [(v) => !!v || this.$t(this.lblSetting.apartmentEntityRequired, {entity: this.$t(this.lblSetting.lblTenant)})],
      numRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartmentForm.number)})],
      buildingName: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartmentForm.buildingName)})],
      floorRules: [v => (!v || (!isNaN(v) || this.$t(this.lblSetting.numberRequired)))],
      surfaceRules: [v => (!v || (!isNaN(v) || this.$t(this.lblSetting.numberRequired)))],
      typeRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartmentForm.type)})],
      emailRules: [
        v => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || this.$t(this.lblSetting.emailValid)
      ]
    }
    if (this.isUpdateAction) { this.dtIsValidLandline = true }
    if (this.$route.meta.apartment_as_block) {
      this.handleGetReferent('')
        .then(response => {
          this.dtTemporaryMaintenanceReferent = response
          this.dtTemporaryVehicleReferent = response
        })
    }
  }

  get lblSetting () {
    return {
      ...require('@/locales/apartment').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get coSearchTypes () {
    return SearchEntities
  }

  get hadBlock () {
    return typeof this.block === 'number' && this.block > 0
  }

  get coMaintenanceReferent () {
    return this.dtTemporaryMaintenanceReferent.filter(x => !!x)
  }

  get coVehicleReferent () {
    return this.dtTemporaryVehicleReferent.filter(x => !!x)
  }

  get coTenants () {
    return this.dtTenants
  }

  set coTenants (val: any[]) {
    this.dtTenants = val.map(item => ({
      id: item.id,
      text: item.fullname ? item.fullname.trim() : `${item.firstname.trim()} ${item.lastname.trim()}`
    }))
  }

  get coOwners () {
    return this.dtOwners
  }

  set coOwners (val: any[]) {
    this.dtOwners = val.map(item => ({
      id: item.id,
      text: item.fullname ? item.fullname.trim() : `${item.firstname.trim()} ${item.lastname.trim()}`
    }))
  }

  get coBlocks () {
    return this.dtBlocks
  }

  set coBlocks (value: any[]) {
    this.dtBlocks = value
  }

  get isUpdateAction (): boolean {
    return this.apartmentCrudActionStatus === CrudStatus.Update
  }

  get isValidLandline (): boolean {
    return !this.landline || (this.landline && this.dtIsValidLandline)
  }

  get telDefaultCountry () {
    return (this.address && this.address.countryCode) || 'fr'
  }

  /*  handleTenantChange(newVal: string) {
       if (newVal && newVal.length)
           this.storeGetEntityAutocomplete({ entity: SearchEntities.Tenant, query: newVal })
               .then(response => {
                   this.coTenants = response
               })
               .catch(err => console.log('error fetching data', err))
   }

   handleOwnerChange(newVal: string) {
       if (newVal && newVal.length)
           this.storeGetEntityAutocomplete({ entity: SearchEntities.Owner, query: newVal })
               .then(response => this.coOwners = response)
               .catch(err => console.log('error fetching data', err))
   } */

  handleBlockChange (newVal: string, cb) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: `${x.name}`, ...x})))
        })
        .catch(error => console.log(error))
    }
  }

  handleGetEntityAutocomplete (newVal: string, cb, typeSearchEntity: SearchEntities) {
    if (newVal && newVal.length > 2) {
      this.storeGetEntityAutocomplete({entity: typeSearchEntity, query: newVal})
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: `${x.firstname} ${x.lastname}`, ...x})))
        })
        .catch(error => console.log(error))
    }
  }

  async handleChangeMaintenanceReferent (event?) {
    // Change maintenance referent
  }

  async handleChangeVehicleReferent (event?) {
    // Change maintenance referent
  }

  handleGetReferent (query: string) {
    return this.storeGetEntitySearch({
      entity: SearchEntities.Referent,
      query: query,
      limit: 100,
      block: this.hadBlock ? [this.block] : null
    })
  }

  onInputLandline ({number, isValid}) {
    this.landline = number
    this.dtIsValidLandline = isValid
  }
}

export default ApartmentVerticalModal



// WEBPACK FOOTER //
// ./src/containers/block/components/block-apartment-vertical-modal/index.ts